module.exports = __webpack_public_path__ + "img/2.40201a2c.jpg";